<template>
    <el-select
        :ref="itConfig.selectRef"
        v-model="itConfig.value"
        :placeholder="itConfig.placeholder"
        :loading="loading"
        :filterable="itConfig.filterable"
        remote
        :remote-method="filterMethod"
        :filter-method="filterMethod"
        @keyup.enter.native="selectOptionOnEnter"
        @keyup.up.native="selectPrevious" 
        @keyup.down.native="selectNext"
    >
    <template #empty>
      <div class="table" :style="{ width: `${itConfig.tableWidth}px` }">
        <el-table
            :ref="itConfig.tableRef"
            :data="tableData"
            border
            style="width: 100%"
            @row-click="rowClick"
            height="300"
            :row-class-name="tableRowClassName"
        >
          <el-table-column
            v-for="item in itConfig.tableColumn"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label"
            :align="item.align || 'center'"
            :show-overflow-tooltip="item.noShowTip"
          >
            <template #default="{ row, $index }">
              <template v-if="item.render">
                <render-col
                  :column="item"
                  :row="row"
                  :render="item.render"
                  :index="$index"
                />
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>
  </el-select>
</template>

<script>
    import { watch, ref } from 'vue'
    export default{
        props:{
            itConfig: {
                type: Object,
                default: {}
            }
        },
        setup(props) {
            let tableData = ref([]);
            let loading = ref(false);
            let selectedValue = ref(null);
            let selectIndex = ref(0);
            watch(() => props.itConfig,(newVal) => {
                tableData.value = newVal.tableData
                selectedValue = null
            },{
                deep:true,
            });
            return { tableData, loading, selectedValue, selectIndex }
        },
        methods: {
            tableRowClassName({row, rowIndex}) {
                if (rowIndex === this.selectIndex) {
                    return 'success-row'
                }
            },
            // 行点击
            rowClick(row, column){
                let that = this
                let index = this.tableData.findIndex(item => item === row);
                this.selectedValue = row;
                this.selectIndex = index;
                that.itConfig.value = row[that.itConfig.showField]
                this.$refs[that.itConfig.selectRef].blur();
                this.$emit('updateValue', row)
            },
            // 搜索
            filterMethod(query, option) {
                if(this.itConfig.isSearch){
                    if(query.trim() !== ''){
                        this.$emit('searchtext', query)
                    }else{
                        this.tableData = []
                    }
                }else{
                    if(query.trim() === ''){
                        this.tableData = this.itConfig.tableData
                    }else {
                        let res = this.fuzzySearch(query)
                        this.tableData = res;
                    }
                }
            },
            // 行模糊搜索匹配
            fuzzySearch(searchTerm) {
                const regex = new RegExp(searchTerm, 'i'); // 'i' 表示不区分大小写
                return this.tableData.filter(item =>
                    Object.values(item).some(value => regex.test(value ? value : ''))
                );
            },
            // 回车选值
            selectOptionOnEnter(event) {
                if (event.key === 'Enter') {
                    let that = this;
                    // 假设options中有对应的value，可以直接赋值
                    let obj = this.selectedValue || this.tableData[0];
                    this.itConfig.value = obj[[this.itConfig.showField]]
                    this.$refs[that.itConfig.selectRef].blur();
                    this.$emit('updateValue', obj)
                }
            },
            // 向上选择
            selectPrevious(event) {
                if (this.selectIndex > 0) {
                    this.selectIndex -= 1;
                    this.selectedValue = this.tableData[this.selectIndex];
                    this.scrollTable();
                }
            },
            // 向下选择
            selectNext(event) {
                if (this.selectIndex < this.tableData.length - 1) {
                    this.selectIndex += 1;
                    this.selectedValue = this.tableData[this.selectIndex];
                    this.scrollTable();
                }
            },
            scrollTable() {
                this.$nextTick(() => {
                    const scrollableEl = this.$refs[this.itConfig.tableRef].$el.querySelector('.el-scrollbar__wrap');
                    if(scrollableEl){
                        const row = this.$refs[this.itConfig.tableRef].$el.querySelector(`.success-row`);
                        if (row) {
                            scrollableEl.scrollTop = row.offsetTop;
                        }
                    }
                })
            }
        },
        mounted() {
            this.tableData = this.itConfig.tableData
        },
    }
</script>

<style>
    .el-table .success-row {
        --el-table-tr-bg-color: var(--el-color-success-light-9);
    }
</style>

